import { useEffect, useState } from 'react';
import { ApolloClient } from '@apollo/client';
import { findServiceContract, findServiceContractBySku } from '../../graphql';
import { PageSteps } from '../../components/sales/sales-common/NewHeader';
import { isStockOrder } from '../constants';

export interface IServiceContract {
  sku?: string;
  serialNo?: string;
  activeStep: PageSteps;
  createdOrderType: string;
  isVarebilEnabled: boolean;
  isUsedCar: boolean;
  isForeignBrand: boolean;
}

export const useServiceContract = (
  client: ApolloClient<object>,
  { serialNo, sku, activeStep = null, createdOrderType, isUsedCar, isVarebilEnabled, isForeignBrand }: IServiceContract
) => {
  const queryCall = isVarebilEnabled
    ? [PageSteps.IMPORTEROPTIONS, PageSteps.SIGN]
    : [PageSteps.FINANACE, PageSteps.IMPORTEROPTIONS];

  const [loading, setLoading] = useState(false);
  const [responseObject, setResponseObject] = useState(null);

  const fetchServiceContract = async () => {
    setLoading(true);
    try {
      if (serialNo) {
        const { data } = await client.query({
          query: findServiceContract,
          variables: {
            serialNo: serialNo,
          },
          context: { clientName: 'sales-common' },
          fetchPolicy: 'network-only',
        });
        setResponseObject(data?.findServiceContract?.responseObject);
      } else if (sku) {
        const { data } = await client.query({
          query: findServiceContractBySku,
          variables: {
            sku: sku,
          },
          context: { clientName: 'sales-common' },
          fetchPolicy: 'network-only',
        });
        setResponseObject(data?.findServiceContractBySku?.responseObject);
      }
    } catch (error) {
      console.error('Error fetching service contract:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (queryCall.includes(activeStep) && !isStockOrder(createdOrderType) && !isUsedCar && !isForeignBrand) {
      fetchServiceContract();
    } else {
      return;
    }
  }, [serialNo, sku, activeStep]);

  const response = {
    data: responseObject?.contractTypeList?.length ? responseObject : null,
    loading,
  };

  return response;
};
